import { render, staticRenderFns } from "./VFilter.vue?vue&type=template&id=675bf9ce"
import script from "./VFilter.vue?vue&type=script&lang=js"
export * from "./VFilter.vue?vue&type=script&lang=js"
import style0 from "./VFilter.vue?vue&type=style&index=0&id=675bf9ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports